// @ts-strict-ignore
import { useGetInfoRequired } from 'hooks/queries/useGetInfoRequiredQuery'
import { EMBEDDED_CUSTOMER_STATUSES } from '../helpers/constants'

export const useChecklistDetails = ({ reference }: { reference: string }) => {
  const { data, isError, isLoading, refetch } = useGetInfoRequired(reference)

  const { infoRequired, status } = data || {}

  const verified = status === EMBEDDED_CUSTOMER_STATUSES.VERIFIED
  const hasPendingAgreements = status === EMBEDDED_CUSTOMER_STATUSES.PENDING_AGREEMENTS

  const questionnairesPending = !!infoRequired?.questionnaires?.length
  const associatesPending = !!infoRequired?.associates?.length
  const dataPending = !!infoRequired?.data?.length
  const documentsPending = !!infoRequired?.documents?.length

  const hasPendingQuestionnaires = hasPendingAgreements || questionnairesPending
  const questionnaireKey = infoRequired?.questionnaires?.[0]

  const hasPendingAssociates =
    !!infoRequired?.associates?.find(a => a.roles).roles?.length ||
    hasPendingAgreements ||
    questionnairesPending

  const hasPendingCompanyInformation =
    hasPendingAgreements ||
    hasPendingQuestionnaires ||
    associatesPending ||
    dataPending ||
    documentsPending

  const completedChecklistCount = [
    !hasPendingAgreements,
    !hasPendingQuestionnaires,
    !hasPendingCompanyInformation,
    verified,
  ].filter(Boolean).length

  const hasAssociatesToAdd = !!infoRequired?.associates?.find(
    a => !a.roles.includes(a.associateName)
  )?.roles?.length

  const checklistBadgeCount = `${completedChecklistCount} / 4`
  return {
    hasPendingAgreements,
    hasPendingQuestionnaires,
    hasPendingCompanyInformation,
    verified,
    questionnaireKey,
    isErrorFetchingChecklist: isError,
    isLoading,
    refetchInfoRequired: refetch,
    checklistBadgeCount,
    hasPendingAssociates,
    hasAssociatesToAdd,
  }
}
